<template>
  <nav aria-label="menu" class="bg-surface-default-low h-48 transition-colors">
    <div
      class="relative w-full"
      :class="[
        !arrivedState.left
          ? `before:from-bg-static-default-low before:absolute before:inset-y-0 before:left-0 before:z-[1] before:h-48 before:w-32 before:bg-gradient-to-r before:to-transparent before:content-['']`
          : '',
        !arrivedState.right
          ? `after:from-bg-static-default-low after:absolute after:inset-y-0 after:right-0 after:z-[1] after:h-48 after:w-32 after:bg-gradient-to-l after:to-transparent after:content-['']`
          : '',
      ]"
    ></div>
    <div class="flex h-full justify-center">
      <ul
        ref="menu"
        class="-mb-4 flex flex-row gap-32 overflow-auto p-4 scrollbar-none"
      >
        <NavMenuItem
          v-for="(item, index) in items"
          :key="item.id"
          class="h-full"
          v-bind="item"
          :position="index"
        />
      </ul>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { useScroll } from '@vueuse/core'

import { useFetchNavigationItems } from '../../composables/useFetchNavigationItems'

import NavMenuItem from './NavMenuItem.vue'

const menu = ref()
const { arrivedState } = useScroll(menu)

const { items } = useFetchNavigationItems()
</script>
